module.exports = __webpack_public_path__ + "media/V127.eb339d81.mp4";